import { redirect } from "react-router-dom";
import { apiGet, API_ROUTES } from "../../configure/apiConfig";
import { validateIsAuthenticated } from "../utils/validateIsAuthenticated";
import { validateIsAuthorized } from "../utils/validateIsAuthorized";
import { validateAndRedirectStatus } from "./validateAndRedirectStatus";
import { CollaboratorPath } from "../../common/lang/locale/MenueditPath";
import {getWithLocalExpiry, setWithLocalExpiry } from "@utils/index";
import { setApplicationPermission } from "@redux/slices/PermissionSlice";

export async function homePageLoader({ params, request,dispatch }) {
  const url = new URL(request.url);
  const pathname = url.pathname;

  //  if(pathname.includes("/undefined")) return null;
  const NotEntry = { data: false, message: "method executed successfully" };

  const isAuthenticated = await validateIsAuthenticated();
  if (!isAuthenticated) {
    sessionStorage.setItem("postLoginRedirect", pathname);
    return redirect("/");
  }

  const isAuthorized = await validateIsAuthorized();
  if (!isAuthorized) return NotEntry;

  const dealid = params.projectid || params.inapnum || params.worksheetid || null;
  const demandid = params.demandid || null;
  if (!dealid) {
    console.warn("Missing deal ID");
    return NotEntry;
  }

  try {
    const token = await getWithLocalExpiry() ;
    if (!token) {
      sessionStorage.setItem("postLoginRedirect", pathname);
      return redirect("/");
    }
    const newRoute = await validateAndRedirectStatus({ pathname, dealid, demandid });
    if (newRoute) return redirect(newRoute);

    const collaboratorEntry = Object.entries(CollaboratorPath)?.find(([_, value]) =>
      pathname?.includes(value)
    );

    if (collaboratorEntry) {
      const response = await apiGet(API_ROUTES.GET_DEAL_COLLABORATORS, {
        type: "verifyCollaborators",
        dealid: dealid, 
        source: collaboratorEntry[0],
      });

      if (!response?.data) return new Response("Permission Denied", { status: 403 });
      const data = response?.data?.token
      if (data) {
        setWithLocalExpiry({value: data?.token});
        localStorage.setItem('employeeId',data.employeeId)
        dispatch(setApplicationPermission(data))
      }

      return response.data;
    }

    return NotEntry;
  } catch (error) {
    console.error("Loader error:", error);

    let message = "Unexpected error occurred";
    let status = 500;

    try {
      const parsed = JSON.parse(error.message || "{}");
      message = parsed.message || message;
      status = parsed.statuscode || status;
    } catch (_) {
      if (error?.response?.status) {
        status = error.response.status;
        message = error.response.statusText || message;
      }
    }

    if (status === 403 || status === 503) {
      return new Response("Permission Denied", { status: 503 });
    }

    if (status === 404) {
      sessionStorage.setItem("postLoginRedirect", pathname);
      return new Response("Page Not Found", { status: 404 });
    }

    return NotEntry;
  }
}
